import { useState, useEffect } from 'react'
import { getParsedItem, setItem } from '@sketch/utils'
import { localStorageKeys } from '@sketch/constants'

export const MAX_SIDEBAR_WIDTH = 360
const MIN_SIDEBAR_WIDTH = 95
const INITIAL_SIDEBAR_WIDTH = MAX_SIDEBAR_WIDTH / 2

const calculateSidebarWidth = (value: number) => {
  return Math.max(MIN_SIDEBAR_WIDTH, Math.min(value, MAX_SIDEBAR_WIDTH))
}

export const useResizeSidebar = () => {
  const canvasSidebarWidth = getParsedItem(localStorageKeys.canvasSidebarWidth)
  const [sidebarWidth, setSidebarWidth] = useState(
    Number(canvasSidebarWidth) || INITIAL_SIDEBAR_WIDTH
  )
  const [trackMouse, setTrackMouse] = useState(false)
  const [restoreInitialWidth, setRestoreInitialWidth] = useState(false)

  const changeSidebarWidth = (event: MouseEvent) => {
    setRestoreInitialWidth(false)
    setSidebarWidth(calculateSidebarWidth(event.x))
    setItem(
      localStorageKeys.canvasSidebarWidth,
      String(calculateSidebarWidth(event.x))
    )
  }

  const changeSidebarWidthEnd = () => {
    setTrackMouse(false)
  }

  const restoreInitialSidebarWidth = () => {
    setRestoreInitialWidth(true)
    setSidebarWidth(INITIAL_SIDEBAR_WIDTH)
    setItem(localStorageKeys.canvasSidebarWidth, String(INITIAL_SIDEBAR_WIDTH))
  }

  useEffect(() => {
    if (!trackMouse) {
      return
    }

    document.addEventListener('mousemove', changeSidebarWidth)
    document.addEventListener('mouseup', changeSidebarWidthEnd)

    return () => {
      document.removeEventListener('mousemove', changeSidebarWidth)
      document.removeEventListener('mouseup', changeSidebarWidthEnd)
    }
  }, [trackMouse])

  return {
    sidebarWidth,
    setTrackMouse,
    minWidth: MIN_SIDEBAR_WIDTH,
    maxWidth: MAX_SIDEBAR_WIDTH,
    restoreInitialWidth,
    restoreInitialSidebarWidth,
  }
}
